import { DataV4 } from 'bones/utils/queryBuilder/migrate/v4/types';
import { ConjunctionV5 } from 'bones/utils/queryBuilder/migrate/v5/constants';
import { DataV5, FilterV5 } from 'bones/utils/queryBuilder/migrate/v5/types';

export const v5 = (data: DataV4): DataV5 => ({
  ...data,
  query: {
    conjunction: data.query.conjunction as unknown as ConjunctionV5.OR,
    expressions: data.query.expressions.map((subExpression) => ({
      conjunction: ConjunctionV5.AND_NOT,
      expressions: [
        {
          filters: subExpression.expressions.reduce<FilterV5[]>(
            (acc, expression) => {
              acc.push(...(expression.filters as unknown as FilterV5[]));
              return acc;
            },
            []
          ),
        },
      ],
    })),
  },
});
